var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('mdb-carousel',{attrs:{"interval":6000,"slide":"","items":_vm.items,"indicators":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }